@if (visible && eCommerceIntegration) {
  <div class="ec-card" [class.ec-card--configured]="isOn">
    <div class="ec-header" [class.ec-header--clickable]="!isOn" (click)="onCardClick()">
      <img class="ec-logo" [src]="eCommerceIntegration.config?.logoUrl" alt="" />
      <div class="ec-name">{{ eCommerceIntegration.type }}</div>
      <div class="ec-spacer"></div>
      @if (saving) {
        <mat-spinner class="ec-spinner" diameter="18" mode="indeterminate"></mat-spinner>
      } @else if (isOn) {
        <span class="ec-active">
          <mat-icon class="ec-status">check</mat-icon>
          {{ "campaign.widget.sidebar.form-settings-v2.active-badge" | translate }}
        </span>
        <button mat-icon-button class="ec-remove" [matTooltip]="'generic.remove' | translate" (click)="onRemove($event)">
          <mat-icon>delete_outline</mat-icon>
        </button>
      } @else {
        <mat-icon class="ec-add">add</mat-icon>
      }
    </div>
  </div>
}
